import { defineComponent as _defineComponent } from 'vue'
interface Props {
  loading?: boolean;
  products: any[];
  perRow?: number;
  totalPagesCount?: number;
  currentPage?: number | string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsList',
  props: {
    loading: { type: Boolean, default: false },
    products: null,
    perRow: { default: 3 },
    totalPagesCount: { default: 0 },
    currentPage: { default: 1 }
  },
  setup(__props: any) {



// const grid = new Map([
//   [3, 'grid-cols-1 sm:grid-cols-2 xl:grid-cols-3'],
//   [4, 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4'],
// ]);
// const gridClasses = computed(() => {
//   return grid.get(props.perRow);
// });

return { __sfc: true, }
}

})